/// <amd-module name="Pipeline/Analytics/Common/Sources/ContributionSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export interface IConstributionSourceOptions {
    pageContext: IVssPageContext;
}

export class ContributionSource {
    private _pageContext: IVssPageContext;

    constructor(options: IConstributionSourceOptions) {
        this._pageContext = options.pageContext;
    }

    public getDataAsync<T = { [key: string]: any }>(contributionId: string, routeValues?: { [key: string]: string }, refresh: boolean = false) {
        return this._service.getDataAsync<T>(contributionId, routeValues, refresh);
    }

    private get _service() {
        return this._pageContext.getService<IVssContributionService>("IVssContributionService");
    }
}
